export default {"src":"/_next/static/media/chart-slateus.77eea239.svg","height":100,"width":101};